import React from 'react';
import { Select } from './Select';
import { OptionObject, SelectProps } from './Select/types';
import { SeverityItem, severityOptions } from './Severity/severity.utils';

type ISeveritySelectProps = Pick<
  SelectProps<string>,
  | 'isMultiple'
  | 'size'
  | 'label'
  | 'variant'
  | 'showInput'
  | 'transparent'
  | 'placeholder'
  | 'displayErrorOnMultiply'
  | 'missingValueErrorText'
  | 'readOnly'
> & {
  filterValue: string | string[];
  onChange: (value: string | string[]) => void;
  options?: OptionObject<string>[];
  showLabel?: boolean;
};

export const SeveritySelect: React.FC<ISeveritySelectProps> = ({
  filterValue,
  onChange,
  options = severityOptions,
  isMultiple = true,
  size = 'small',
  showLabel = true,
  label = 'Severity',
  variant = 'filter',
  showInput = false,
  transparent = false,
  readOnly = false,
  placeholder = '',
  displayErrorOnMultiply = false,
  missingValueErrorText,
}) => (
  <Select
    {...(showLabel && { label })}
    size={size}
    value={filterValue as string}
    onChange={val => onChange(val)}
    options={options}
    renderOption={(option: OptionObject<string>) => <SeverityItem value={option.value as string} />}
    isMultiple={isMultiple}
    variant={variant}
    showInput={showInput}
    transparent={transparent}
    readOnly={readOnly}
    placeholder={placeholder}
    displayErrorOnMultiply={displayErrorOnMultiply}
    missingValueErrorText={missingValueErrorText}
  />
);
